<template>
  <v-dialog max-width="800px" :value="dialog" @input="onClose">
    <v-card>
      <v-card-text>
        <v-layout align-center justify-center row wrap>
          <v-flex shrink v-if="receipt">
            <img class="image-preview" :src="receipt" />
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "receiptImage",
  props: {
    dialog: {
      required: false,
      default: false
    }
  },
  data() {
    return {
      receipt: null
    };
  },
  methods: {
    onClose() {
      this.$emit("update:dialog", false);
      this.receipt = null;
    },
    setValue(receipt) {
      this.receipt = receipt;
    }
  }
};
</script>

<style scoped>
.image-preview {
  max-width: 100%;
}
</style>
